import React from "react";
import { Facebook, Instagram, Linkedin, X } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0B0B0B] pt-12 mt-auto">
      <div className="max-w-7xl mx-auto px-4 md:px-6">

        {/* ================= MAIN FOOTER CARD ================= */}
        <div className="relative bg-black rounded-3xl py-14 px-6 md:px-12 text-center overflow-hidden">

          {/* Subtle gradient highlights */}
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute -top-24 -left-24 w-96 h-96 bg-white/5 rounded-full blur-3xl" />
            <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-white/5 rounded-full blur-3xl" />
          </div>

          {/* Logo */}
          <div className="relative z-10 flex justify-center items-center gap-3 mb-10">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-red-600 to-red-800 flex items-center justify-center text-white font-bold text-lg">
              D
            </div>
            <span className="text-white text-xl font-semibold tracking-wide">
              Daily Go
            </span>
          </div>

          {/* Navigation */}
          <nav className="relative z-10 flex flex-wrap justify-center gap-x-10 gap-y-4 text-gray-300 text-sm mb-10">
            <a href="/" className="hover:text-white transition">Home</a>
            <a href="https://dailygolive.in/" className="hover:text-white transition">Official Site</a>
            <a href="https://dailygolive.in/ServiceIndex" className="hover:text-white transition">Services</a>
            <a href="https://dailygolive.in/AboutUsIndex" className="hover:text-white transition">About Us</a>
            <a href="https://dailygolive.in/PrivacyPolicyIndex" className="hover:text-white transition">Privacy Policy</a>
            <a href="https://dailygolive.in/TermsAndConditionIndex" className="hover:text-white transition">Terms & Conditions</a>
          </nav>

          {/* Social Icons */}
          <div className="relative z-10 flex justify-center gap-6 text-gray-400">
            <a href="#" className="hover:text-white transition"><Facebook size={20} /></a>
            <a href="#" className="hover:text-white transition"><X size={20} /></a>
            <a href="#" className="hover:text-white transition"><Instagram size={20} /></a>
            <a href="#" className="hover:text-white transition"><Linkedin size={20} /></a>
          </div>
        </div>

        {/* ================= BOTTOM BAR ================= */}
        <div className="mt-8 border-t border-white/10 py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-400">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-full bg-gradient-to-br from-red-600 to-red-800 flex items-center justify-center text-white text-xs font-bold">
              D
            </div>
            <span>Daily Go</span>
          </div>

          <p className="text-center">
            © {new Date().getFullYear()} Daily Go. All rights reserved.
          </p>

          <div className="flex gap-4">
            <Facebook size={18} />
            <X size={18} />
            <Linkedin size={18} />
            <Instagram size={18} />
          </div>
        </div>

      </div>
    </footer>
  );
}
